import React from "react";
import { getSweepsCoinName } from "../../utility/complianceCopy";

export const playthroughPercent = (played, target) => {
  const denominator = Number(target);
  if (!Number.isFinite(denominator) || denominator <= 0) return 0;
  return Math.min(100, Math.max(0, (Number(played || 0) / denominator) * 100));
};

export default function PlaythroughProgress({ played = 0, target = 0, locked = 0 }) {
  const percent = playthroughPercent(played, target);
  if (Number(target) <= 0 && Number(locked) <= 0) return null;
  return <section className="dts-playthrough" aria-label={`${getSweepsCoinName()} play-through progress`}>
    <div><span>Play-through progress</span><strong>{percent.toFixed(0)}%</strong></div>
    <progress max="100" value={percent}>{percent}%</progress>
    <small>{Number(played).toFixed(2)} of {Number(target).toFixed(2)} played · {Number(locked).toFixed(2)} locked</small>
  </section>;
}
